import React from 'react';
import { Box, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import DrawerFeedback from './DrawerFeedback';
import useNavColors from './navColors';

interface DrawerFooterProps {
    isOpen: boolean;
    handleToggle: () => void;
}

const DrawerFooter: React.FC<DrawerFooterProps> = ({ isOpen, handleToggle }) => {
    const navColors = useNavColors();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                mt: 'auto',
            }}
        >
            <DrawerFeedback isOpen={isOpen} />
            <Box
                sx={{
                    display: 'flex',
                    px: 0.75,
                    py: 1,
                }}
            >
                <IconButton
                    onClick={handleToggle}
                    sx={{
                        color: navColors.icon,
                        fontSize: '24px',
                        '&:hover': {
                            backgroundColor: navColors.linkHoverBgColor,
                        },
                    }}
                >
                    {isOpen ? <ChevronLeft /> : <ChevronRight />}
                </IconButton>
            </Box>
        </Box>
    );
};

export default DrawerFooter;
